
























import { unixTimestampToDateTime } from '@/utils'
import { avatarInitial } from '@/utils/avatar'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { UserAvatar } from '@/modules/shared/components/UserAvatar'

@Component({
  components: {
    UserAvatar
  }
})
export default class DiscussionMessage extends Vue {
  @Prop({ type: String, default: '{message}' }) readonly message!: string
  @Prop({ type: String, default: '{username}' }) readonly name!: string
  @Prop({ type: String, default: '' }) readonly avatar!: string
  @Prop({ type: Number, required: true }) readonly time!: string

  get avatarName() {
    return avatarInitial(this.name)
  }

  get commentTime() {
    return this.$moment(parseInt(this.time) * 1000).fromNow()
  }
}
